import React from 'react';
import './Popups.css';

const MessagePopup = ({ show, title, message, onClose }) => {
  if (!show) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-card">
        <h3 className="popup-title">{title}</h3>
        <p className="popup-message">{message}</p>

        <div className="popup-buttons">
          <button className="popup-btn ok" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessagePopup;

